import { useEffect } from 'react';
import { Image } from 'react-native';
import Animated, {
  cancelAnimation,
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

import { useColorScheme } from '@/hooks/use-color-scheme';

const BOUNCE_DISTANCE = 14;
const BOUNCE_DURATION_MS = 500;
const DEFAULT_SIZE = 44;

type FimBouncingLogoProps = {
  size?: number;
};

/**
 * The Fim assistant logo (same icon as the chat FAB) bouncing gently side to
 * side. Reusable loading indicator for anywhere Fim is "working".
 */
export function FimBouncingLogo({ size = DEFAULT_SIZE }: FimBouncingLogoProps) {
  const colorScheme = useColorScheme();
  const fimIconSource = colorScheme === 'dark'
    ? require('@/assets/images/aichat-dark.png')
    : require('@/assets/images/aichat.png');

  const translateX = useSharedValue(-BOUNCE_DISTANCE);

  useEffect(() => {
    translateX.value = withRepeat(
      withTiming(BOUNCE_DISTANCE, {
        duration: BOUNCE_DURATION_MS,
        easing: Easing.inOut(Easing.quad),
      }),
      -1,
      true,
    );
    return () => cancelAnimation(translateX);
  }, [translateX]);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: translateX.value }],
  }));

  return (
    <Animated.View style={animatedStyle}>
      <Image
        source={fimIconSource}
        style={{ width: size, height: size, borderRadius: size / 2 }}
      />
    </Animated.View>
  );
}
